import { useEffect } from 'react'
import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

import { setTidalThemeActive } from './store'
export function useTidalThemeEnabled() {
  const tidalTheme = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.TidalTheme),
  )

  const enabled = tidalTheme?.enabled ?? false

  // if the feature flag is disabled or missing, ensure the tidal theme is not active
  useEffect(() => {
    if (!enabled) {
      setTidalThemeActive(false)
    }
  }, [enabled])
  return enabled
}
